module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAuCAYAAABqK0pRAAAABHNCSVQICAgIfAhkiAAAAQ9JREFUaEPtlTEKwkAQRSfEYKOtlZWFWloKloLHsLEUa68gnsALeIF0QkjlDWyCN7CwlcAiCrFRScjww0AIP+3un+y8N8l69428pAGPx0ZqZpFGaiZEaIRGjAhwtIzAwmVpBEZnFKQRDdjO8iitwSzbmp4PkkY7TQzaY2qku44kGM0/jUR7eYRb6JCaEBvRUKIRDaW/PRwtDTSOloYSRyuH0vfoABB/IlXvmUofe2MaaU9X4veGhTKC8UL8/iRbd5dQnrekcK+7xuKSEyy2kpGyt/KvVUYoZ51GNNA4WhpKvBABShwtAJrpXws4DxxhIzA6oyCNGIGFy9IIjM4oSCNGYOGyNAKjMwrSiBFYuOwbDQHqLexR05wAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/index/info.png
// module id = 3hnx
// module chunks = 1